module.exports = __webpack_public_path__ + "img/homeBlack.de0496cc.svg";